<template>
  <div>
    <div v-if="remindList.length === 0" style="color: grey">暂无催款信息</div>
    <el-row v-for="(item, index) in remindList" :key="index" style="padding: 10px">
      <el-card shadow="never" style="height: 120px">
        <el-col :span="12">
          <div style="font-size: 16px">第{{ remindList.length - index }}次催单</div>
          <div style="margin-top: 5px; font-size: 12px; color: #b5b4bf">{{ item.sremindTime }}</div>
          <div v-if="item.sreplayCode === '1'" style="margin-top: 5px; font-size: 16px">备货中</div>
          <div v-if="item.sreplayCode === '2'" style="margin-top: 5px; font-size: 16px">已送出</div>
          <div v-if="item.sreplayCode === '3'" style="margin-top: 5px; font-size: 16px">天气原因</div>
          <div v-if="item.sreplayCode === '6'" style="margin-top: 5px; font-size: 16px">{{ item.sreplayMsg }}</div>
          <div style="margin-top: 5px; font-size: 12px; color: #b5b4bf">{{ item.treplay + " " + item.sreplay }}</div>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-dropdown v-if="item.status === 1" @command="handleReplay">
            <el-button type="primary">回复用户<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">备货中</el-dropdown-item>
              <el-dropdown-item command="2">已送出</el-dropdown-item>
              <el-dropdown-item command="3">天气原因</el-dropdown-item>
              <el-dropdown-item command="6">自定义</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-else type="info" plain>已回复</el-button>
        </el-col>
      </el-card>
      <div>
        <el-input v-model="replyContent" class="marginTop5" type="textarea"></el-input>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "OrderRemind",
  props: {
    orderId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      remindList: [],
      replyContent: "",
    };
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      let url = `${this.baseUrls.remind}/queryList`;
      let params = {
        orderId: this.orderId,
      };
      this.topsAjax.get(url, params).then((response) => {
        this.remindList = response;
      });
    },
    handleReplay(replyType) {
      if (replyType === "6" && this.replyContent === "") {
        this.$message({ message: "请输入回复内容", type: "warning" });
        return;
      }
      let url = `${this.baseUrls.remind}/reply`;
      let params = {
        ordId: this.orderId,
        replyType,
        replyContent: this.replyContent,
      };
      this.topsAjax.post(url, params).then(() => {
        this.$message.success("回复成功");
        this.$emit("handleConfirm");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
